import React, { useEffect, useRef, useState } from "react";
import { ViewSelectedCandidateList } from "../../../Redux/action/VendorDashboardAction";
import { GetSelectedPurchaseDetails } from "../../../Redux/action/PurchaseOrderAction";
import { useDispatch, useSelector } from "react-redux";
import { IoSearch } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Pagination from "../../Common/Pagination/Pagination";
import { FiFilter } from "react-icons/fi";
import { IoEyeSharp } from "react-icons/io5";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Accordion, Table } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { RiExchangeFill } from "react-icons/ri";
import { ChangeStatusOfPurchaseOrder } from "../../../Services/parchaseOrderServices";
import { ImCancelCircle } from "react-icons/im";
import { BsCheckCircleFill, BsXCircleFill } from "react-icons/bs";
import { AiOutlineClockCircle } from "react-icons/ai";

export const PurchaseOrderList = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("ALL");
  const [status, setStatus] = useState("ALL");
  const [pageNumber, setPageNumber] = useState(0);
  const [size, setSize] = useState(8);
  const loader = useSelector((state) => state?.PurchaseOrderDetails?.loading);
  const totalPages = useSelector(
    (state) => state?.PurchaseOrderDetails?.result?.totalPages
  );
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(
      GetSelectedPurchaseDetails({
        search,
        size,
        pageNumber,
        activeTab,
        status,
      })
    );
  }, [pageNumber, activeTab, search, status]);

  useEffect(() => {
    setPageNumber(0);
  }, [search]);
  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);

  const purchase_details = useSelector(
    (state) => state?.PurchaseOrderDetails?.result?.content
  );
  // console.log("PPPPPPPPPP ",purchase_details)

  let lastCandidateId = null;
  let colorToggle = false;

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
      className="can_prof_container"
      style={{ minHeight: "100vh", backgroundColor: "#f6f9ff" }}
    >
      <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
        <div style={{ paddingTop: "3px" }}>
          <div
            className="common_wrapper "
            style={{ width: "95%", backgroundColor: "white" }}
          >
            <div
              className="card-header common_table_header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 10,
              }}
            >
              <div style={{ fontSize: width < 600 ? "12px" : "" }}>
                Purchase Order List
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: width < 768 ? "flex-end" : "",
                  gap: 16,
                }}
              >
                <div style={{ position: "relative", display: "inline-block" }}>
                  <FiFilter
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "8px",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                    }}
                  />
                  <select
                    style={{
                      padding: "4px 12px 4px 32px", // Padding adjusted to make space for the icon
                      borderRadius: "4px",
                      fontSize: "16px",
                      border: "1px solid #e2e8f0",
                      appearance: "none", // This hides the default dropdown arrow
                    }}
                    id="select"
                    value={activeTab}
                    onChange={(e) => setActiveTab(e.target.value)}
                  >
                    <option value="ALL">All</option>
                    <option value="SUPPLIER_ORDER">SUPPLIER ORDER</option>
                    <option value="CLIENT_ORDER">CLIENT ORDER</option>
                    <option value="CANDIDATE_ORDER">CANDIDATE ORDER</option>
                  </select>
                </div>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <FiFilter
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "8px",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                    }}
                  />
                  <select
                    style={{
                      padding: "4px 12px 4px 32px", // Padding adjusted to make space for the icon
                      borderRadius: "4px",
                      fontSize: "16px",
                      border: "1px solid #e2e8f0",
                      appearance: "none", // This hides the default dropdown arrow
                    }}
                    id="select"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="ALL">All</option>
                    <option value="PENDING">PENDING</option>
                    <option value="ACCEPTED">ACCEPTED</option>
                    <option value="REJECTED">REJECTED</option>
                  </select>
                </div>
                <div
                  style={{
                    width: width > 767 ? "13rem" : "10rem",
                    backgroundColor: "white",
                    borderRadius: "0.275rem",
                    display: "flex",
                    border: "1px solid #eee6e4",
                  }}
                >
                  <div
                    style={{
                      width: "2rem",
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <IoSearch
                      style={{ color: "#286A94", fontSize: "1.25rem" }}
                    />
                  </div>
                  <input
                    className="small-placeholder"
                    style={{
                      width: "100%",
                      height: "66.67%",
                      margin: "auto 0",
                      paddingLeft: "0.5rem",
                      outline: "none",
                      border: "none",
                    }}
                    placeholder="Search by name"
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="card-body ">
              <div className="table-responsive">
                <table
                  className="table-data text-start"
                  style={{
                    width: "100%",
                    fontSize: "14px",
                    overflowX: "auto",
                    minWidth: "63.5rem",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(7, 1fr)",
                        textAlign: "start",
                        wordBreak: "break-word",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      {" "}
                      {/* Use display: contents to allow grid styling to take effect */}
                      <th className="fw_600" scope="col">
                        Buyer Company
                      </th>
                      <th className="fw_600" scope="col">
                        Supplier Company
                      </th>
                      <th className="fw_600" scope="col">
                        Start Date
                      </th>
                      <th className="fw_600" scope="col">
                        Candidate Name
                      </th>
                      <th className="fw_600" scope="col">
                        Order Type
                      </th>
                      <th className="fw_600" scope="col">
                        Acceptance Status
                      </th>
                      <th className="fw_600" scope="col">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-start">
                    {loader ? (
                      <tr>
                        <td colSpan="8" className="text-center">
                          <div style={{ padding: "20px" }}>
                            <Spinner style={{ color: "#286a94" }} />
                          </div>
                        </td>
                      </tr>
                    ) : purchase_details?.length > 0 ? (
                      purchase_details?.map((item, i) => {
                        const isSameCandidate =
                          item.candidateEmpId === lastCandidateId;
                        if (!isSameCandidate) {
                          colorToggle = !colorToggle; // Toggle color for new candidateId
                        }
                        lastCandidateId = item?.candidateEmpId;
                        return (
                          <tr
                            key={i}
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(7, 1fr)",
                              textAlign: "stat",
                              wordBreak: "break-word",
                              fontFamily: "Poppins, sans-serif",
                              backgroundColor: colorToggle
                                ? "rgb(237 237 237 / 45%)"
                                : "#ffffff",
                            }}
                          >
                            <td>{item.interviewerCompanyName}</td>
                            <td>
                              {item.candidateVendorCompany || "Individual"}
                            </td>
                            <td>{item.startDate}</td>
                            <td>{item.candidateName}</td>
                            <td>
                              {item.purchaseOrderType?.split("_").join(" ")}
                            </td>
                            <td>
                              <span
                                style={{
                                  borderRadius: 10,
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  padding: "4px 12px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  color:
                                    item?.purchaseOrderAcceptanceStatus ===
                                    "ACCEPTED"
                                      ? "#007d3b" // green
                                      : item?.purchaseOrderAcceptanceStatus ===
                                        "REJECTED"
                                      ? "#a50000" // red
                                      : "#996c00", // yellow
                                  backgroundColor:
                                    item?.purchaseOrderAcceptanceStatus ===
                                    "ACCEPTED"
                                      ? "#cbffe1"
                                      : item?.purchaseOrderAcceptanceStatus ===
                                        "REJECTED"
                                      ? "#ffd6d6"
                                      : "#fff5c0",
                                }}
                              >
                                {/* Conditional icon based on status */}
                                {item.purchaseOrderAcceptanceStatus ===
                                  "ACCEPTED" && <BsCheckCircleFill />}
                                {item.purchaseOrderAcceptanceStatus ===
                                  "REJECTED" && <BsXCircleFill />}
                                {item.purchaseOrderAcceptanceStatus ===
                                  "PENDING" && <AiOutlineClockCircle />}

                                {item.purchaseOrderAcceptanceStatus
                                  .split("_")
                                  .join(" ")}
                              </span>
                            </td>
                            <td>
                              <div
                                style={{ paddingLeft: 10, paddingRight: 10 }}
                              >
                                <IoEyeSharp
                                  onClick={() =>
                                    navigate(
                                      `/admin/purchase_order/detail?candidateId=${item.candidateId}&vendorId=${item.interviewerVendorId}&purchaseId=${item.purchaseOrderId}&interviewId=${item?.interviewId}`,
                                      {
                                        state: {
                                          jobId: item?.jobId,
                                          interviewId: item?.interviewId,
                                          interviewerVendorId:
                                            item?.interviewerVendorId,
                                          candidateVendorId:
                                            item?.candidateVendorId,
                                        },
                                      }
                                    )
                                  }
                                  style={{
                                    fontSize: "18px",
                                    color: "#286a94",
                                    cursor: "pointer",
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          <h5
                            style={{ fontSize: "14px", paddingTop: "10px" }}
                            className="fw-600"
                          >
                            No Data Found
                          </h5>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div>
                {purchase_details?.length >= 1 ? (
                  <Pagination
                    totalPages={totalPages}
                    currentPage={pageNumber}
                    onPageChange={handlePageChange}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const OrderPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const optionsRef = useRef();
  const [pageNumber, setPageNumber] = useState(0);
  const [showOptionsForId, setShowOptionsForId] = useState(null); // State to track which row's options are shown
  const [search, setSearch] = useState("");
  const [size, setSize] = useState(9);
  const [cancelModal, setCancelModal] = useState(false);
  const [loaderC, setLoaderC] = useState(false);
  const [orderId, setOrderId] = useState();
  const [status, setStatus] = useState("");
  useEffect(() => {
    setPageNumber(0);
  }, [search]);

  useEffect(() => {
    dispatch(ViewSelectedCandidateList({ pageNumber, size, search }));
  }, [pageNumber, search, cancelModal]);

  const handleChange = () => {
    setLoaderC(true);
    ChangeStatusOfPurchaseOrder(orderId, status)
      .then((res) => {
        console.log("res data", res);
        setLoaderC(false);
        setCancelModal(false);
      })
      .catch((error) => {
        console.log("error data", error);
        setLoaderC(false);
      });
  };

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  const toggleOptions = (id) => {
    setShowOptionsForId(showOptionsForId === id ? null : id);
  };

  useEffect(() => {
    // Function to handle clicks outside the options menu
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setShowOptionsForId(null); // Close options menu if clicked outside
      }
    };
    // Add event listener to handle clicks outside the menu
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const loader = useSelector((state) => state?.VendorSideDashboard?.loading);
  const totalPages = useSelector(
    (state) => state?.VendorSideDashboard?.result?.totalPages
  );
  const SelectedCandidateData = useSelector(
    (state) => state?.VendorSideDashboard?.result?.content
  );
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
      style={{
        paddingTop: "20px",
        paddingBottom: "20px",
        backgroundColor: "#f6f9ff",
        minHeight: "100vh",
      }}
    >
      <ToastContainer />
      <div style={{ paddingTop: "3px" }}>
        <div
          className="common_wrapper "
          style={{ width: "95%", backgroundColor: "white" }}
        >
          <div
            className="card-header common_table_header"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div style={{ fontSize: width > 500 ? "" : "12px" }}>
              Selected Candidate List
            </div>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <div
                style={{
                  border: "2px solid black",
                  height: "36px",
                  backgroundColor: "white",
                  borderRadius: "0.275rem",
                  display: "flex",
                  border: "1px solid #eee6e4",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "2rem",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <IoSearch style={{ color: "#286A94", fontSize: "1.25rem" }} />
                </div>
                <input
                  className="small-placeholder"
                  style={{
                    width: "100%",
                    height: "66.67%",
                    margin: "auto 0",
                    paddingLeft: "0.5rem",
                    outline: "none",
                    border: "none",
                  }}
                  placeholder="Search by id,name"
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div
            className="card-body overflow-x-scroll"
            style={{ overflowX: "scroll" }}
          >
            <div className="mt-4" style={{ minWidth: "1150PX" }}>
              <Accordion defaultActiveKey="0">
                {SelectedCandidateData?.length > 0 ? (
                  SelectedCandidateData?.map((job, index) => (
                    <Accordion.Item eventKey={index.toString()} key={job.jobId}>
                      <Accordion.Header>
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                          }}
                        >
                          {/* First column */}
                          <div style={{ flex: 1, textAlign: "left" }}>
                            Job Id :{" "}
                            <span style={{ fontWeight: 600, color: "black" }}>
                              {job.jobUuid}
                            </span>
                          </div>

                          {/* Second column */}
                          <div style={{ flex: 1, textAlign: "left" }}>
                            Job Name :{" "}
                            <span style={{ fontWeight: 600, color: "black" }}>
                              {job?.jobName || "N/A"}
                            </span>
                          </div>

                          {/* Third column */}
                          <div style={{ flex: 1, textAlign: "right" }}>
                            Selected Candidates :{" "}
                            <span
                              style={{
                                fontWeight: 600,
                                color: "black",
                                marginRight: 6,
                              }}
                            >
                              {job.candidateCount}
                            </span>
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Table hover responsive>
                          <thead>
                            <tr>
                              <th>Buyer Company</th>
                              <th>Supplier Company</th>
                              <th>Candidate Name</th>
                              <th>Interview Date</th>
                              <th>Designation</th>
                              <th>PO Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody className="text-start">
                            {loader ? (
                              <tr>
                                <td colSpan="8" className="text-center">
                                  <div style={{ padding: "20px" }}>
                                    <Spinner style={{ color: "#286a94" }} />
                                  </div>
                                </td>
                              </tr>
                            ) : job?.candidates?.length > 0 ? (
                              job?.candidates?.map((item, i) => (
                                <tr key={i}>
                                  <td>{item?.interviewerCompanyName}</td>
                                  <td>
                                    {item?.candidateCompanyName || "Individual"}{" "}
                                  </td>
                                  <td>{item?.candidateName}</td>
                                  <td>{item?.interviewDate?.split(" ")[0]}</td>
                                  <td>{item?.jobPosition}</td>
                                  <td>
                                    <span
                                      style={{
                                        borderRadius: 10,
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        padding: "4px 12px",
                                        color:
                                          item?.PurchaseOrderCreated ===
                                          "Accepted"
                                            ? "#007d3b" // green
                                            : item?.PurchaseOrderCreated ===
                                              "Rejected"
                                            ? "#a50000" // red
                                            : "#996c00", // yellow

                                        backgroundColor:
                                          item?.PurchaseOrderCreated ===
                                          "Accepted"
                                            ? "#cbffe1"
                                            : item?.purchaseOrderCreated ===
                                              "Rejected"
                                            ? "#ffd6d6"
                                            : "#fff5c0",
                                      }}
                                    >
                                      {item?.PurchaseOrderCreated || "N/A"}
                                    </span>
                                  </td>
                                  <td className="d-flex">
                                    <div style={{ paddingLeft: 10 }}>
                                      <IoEyeSharp
                                        onClick={() =>
                                          navigate(
                                            `/admin/selected-candidate/details?candidateId=${item?.candidateId}&vendorId=${item?.interviewerVendorId}&interviewId=${item?.interviewId}`,
                                            {
                                              state: {
                                                jobId: item?.jobId,
                                                interviewId: item?.interviewId,
                                                interviewerVendorId:
                                                  item?.interviewerVendorId,
                                                candidateVendorId:
                                                  item?.candidateVendorId,
                                              },
                                            }
                                          )
                                        }
                                        style={{
                                          fontSize: "18px",
                                          color: "#286a94",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </div>
                                    {item?.PurchaseOrderCreated ===
                                      "Pending" && (
                                      <div style={{ paddingLeft: 10 }}>
                                        <RiExchangeFill
                                          onClick={() => {
                                            setCancelModal(true);
                                            setOrderId(item?.interviewId);
                                            setStatus("On_Hold");
                                          }}
                                          style={{
                                            fontSize: "18px",
                                            color: "#286a94",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </div>
                                    )}
                                    {item?.PurchaseOrderCreated ===
                                      "On_Hold" && (
                                      <div style={{ paddingLeft: 10 }}>
                                        <ImCancelCircle
                                          onClick={() => {
                                            setCancelModal(true);
                                            setOrderId(item?.interviewId);
                                            setStatus("Rejected");
                                          }}
                                          style={{
                                            fontSize: "18px",
                                            color: "#286a94",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <div className="d-flex align-item-center justify-content-center">
                                No Data Found
                              </div>
                            )}
                          </tbody>
                        </Table>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))
                ) : (
                  <div className="d-flex align-item-center justify-content-center">
                    No Data Found
                  </div>
                )}
              </Accordion>
            </div>
          </div>
          <div>
            {SelectedCandidateData?.length >= 1 ? (
              <Pagination
                totalPages={totalPages}
                currentPage={pageNumber}
                onPageChange={handlePageChange}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <Modal
        show={cancelModal}
        onHide={() => {
          setCancelModal(false);
          setOrderId();
        }}
        backdrop="static"
        keyboard={false}
        style={{ top: "30%" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Do you want to {status == "Rejected" ? "Reject" : "hold"} this
          candidate?
        </Modal.Body>
        <Modal.Footer
          className="flex-center"
          style={{ justifyContent: "center" }}
        >
          <Button
            className="btn-primary-custom"
            disabled={loaderC}
            onClick={() => handleChange()}
          >
            {loaderC ? "loading..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OrderPage;
